export default function ServiceGrid() {
  return (
    <section id="services" className="relative bg-background-50 py-20 md:py-28 px-6 md:px-10 lg:px-16">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-14 md:mb-20">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight">
            What We <span className="text-primary-500">Transport</span><br />
            <span className="text-primary-500">&amp; Protect</span>
          </h2>
          <p className="mt-5 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Three specialized divisions, each built for a specific class of high-value logistics — from sensitive documents to assets requiring armed security.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-5 md:gap-6">
          <div className="lg:w-1/2 relative group rounded-2xl overflow-hidden cursor-pointer h-[360px] md:h-[520px]">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20professional%20courier%20handling%20a%20sealed%20document%20envelope%20in%20a%20minimalist%20modern%20office%20lobby%20with%20soft%20natural%20lighting%2C%20wearing%20a%20tailored%20dark%20suit%20with%20white%20gloves%2C%20luxurious%20atmosphere%20with%20marble%20flooring%20and%20warm%20neutral%20tones%2C%20premium%20corporate%20aesthetic%2C%20clean%20composition%2C%20shallow%20depth%20of%20field%20focusing%20on%20the%20hands%20and%20package&width=900&height=1200&seq=service-white-glove-01&orientation=portrait"
              alt="White-glove courier handling premium documents"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-6 md:p-8">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-white text-xs font-semibold tracking-wide mb-3">
                MOST REQUESTED
              </span>
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-white mb-2">White-Glove Courier</h3>
              <p className="text-white/80 text-sm max-w-sm">
                Documents, electronics, legal papers, and medical samples delivered with personal handling and chain-of-custody protocols.
              </p>
            </div>
          </div>

          <div className="lg:w-1/2 flex flex-col gap-5 md:gap-6">
            <div className="relative group rounded-2xl overflow-hidden cursor-pointer h-[170px] md:h-[248px] bg-secondary-200">
              <img
                src="https://readdy.ai/api/search-image?query=Premium%20armored%20security%20transport%20vehicle%20in%20motion%20on%20a%20modern%20city%20street%20at%20dusk%2C%20sleek%20black%20reinforced%20vehicle%20with%20subtle%20gold%20accents%2C%20professional%20security%20aesthetic%2C%20dramatic%20evening%20lighting%20with%20warm%20street%20reflections%2C%20cinematic%20mood%2C%20clean%20and%20sophisticated%20atmosphere&width=1000&height=600&seq=service-armed-transport-02&orientation=landscape"
                alt="Armored security transport vehicle"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-transparent"></div>
              <div className="absolute bottom-0 left-0 p-5 md:p-6">
                <h3 className="text-xl md:text-2xl font-heading font-bold text-white mb-1">Armed Transport</h3>
                <p className="text-white/75 text-xs md:text-sm max-w-xs">
                  Armored vehicles, certified security personnel, and GPS-tracked routes for maximum-value cargo.
                </p>
              </div>
            </div>

            <div className="relative group rounded-2xl overflow-hidden cursor-pointer h-[170px] md:h-[248px] bg-accent-100">
              <img
                src="https://readdy.ai/api/search-image?query=Interior%20of%20a%20luxurious%20private%20bank%20vault%20with%20rows%20of%20polished%20steel%20safety%20deposit%20boxes%20illuminated%20by%20warm%20ambient%20lighting%2C%20rich%20mahogany%20accents%2C%20reflective%20marble%20floor%2C%20opulent%20secure%20atmosphere%2C%20high-end%20interior%20design%2C%20editorial%20photography%2C%20warm%20golden%20and%20bronze%20tones&width=1000&height=600&seq=service-vault-insurance-03&orientation=landscape"
                alt="Secure vault interior with safety deposit boxes"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/45 to-transparent"></div>
              <div className="absolute bottom-0 left-0 p-5 md:p-6">
                <h3 className="text-xl md:text-2xl font-heading font-bold text-white mb-1">Vault &amp; Insurance</h3>
                <p className="text-white/75 text-xs md:text-sm max-w-xs">
                  Climate-controlled vaulting and declared-value insurance up to the full replacement cost of your assets.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}